import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';          // 引入 Tailwind 样式
import PersonalWebsite from './personal-website-xxw';

ReactDOM.render(
  <React.StrictMode>
    <PersonalWebsite />
  </React.StrictMode>,
  document.getElementById('root')
);
